import { render, staticRenderFns } from "./rulePopup.vue?vue&type=template&id=47f99514&scoped=true"
import script from "./rulePopup.vue?vue&type=script&lang=js"
export * from "./rulePopup.vue?vue&type=script&lang=js"
import style0 from "./rulePopup.vue?vue&type=style&index=0&id=47f99514&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f99514",
  null
  
)

export default component.exports